/**
 * Bridges the surface grid and active underground layer to LayerDependencyValidator.
 */
import { Grid, BuildingType } from '../types';
import { UndergroundLayer, Position3D } from '../types/underground';
import { LayerDependencyValidator } from '../services/layerDependencyValidator';

export interface PlacementValidationResult {
  isValid: boolean;
  message?: string;
  severity?: 'critical' | 'high' | 'medium' | 'low';
}

let validatorInstance: LayerDependencyValidator | null = null;

const getValidator = (): LayerDependencyValidator => {
  if (!validatorInstance) {
    validatorInstance = new LayerDependencyValidator();
  }
  return validatorInstance;
};

/** Reset validator singleton — test helper */
export const resetLayerPlacementValidator = (): void => {
  validatorInstance = null;
};

/**
 * Validate whether a building can be placed at the given grid cell on the active layer.
 */
export const validateBuildingPlacement = (
  grid: Grid,
  activeLayer: UndergroundLayer,
  x: number,
  y: number,
  buildingType: BuildingType,
): PlacementValidationResult => {
  if (buildingType === BuildingType.None) {
    return { isValid: true };
  }

  const validator = getValidator();
  validator.syncFromGameGrid(grid);

  const position: Position3D = { x, y, z: activeLayer };
  const result = validator.validatePlacement(position, buildingType);

  if (result.isValid) {
    return { isValid: true };
  }

  const primary = result.errors[0];
  return {
    isValid: false,
    message: primary?.message ?? 'Placement blocked by layer dependency rules.',
    severity: primary?.severity,
  };
};